import React from 'react';
import { useSelector } from 'react-redux';
import { Typography } from '@dev/ee-components';
import styled from 'styled-components';

import { getContactsStore } from '@/store/contacts/actions';
import { validationColors } from '../AnalyticsGraph';

const LegendItem = styled.div`
    width: 165px;
    margin: 0 20px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
    padding: 16px 24px;
    .legendColor {
        display: inline-block;
        width: 12px;
        height: 12px;
        margin-right: 8px;
        border-radius: 3px;
    }
    &:hover {
        box-shadow: 0px 0px 16px #67679d1f;
    }
`;

const NumberRow = styled.div`
    display: flex;
    align-items: center;
    .MuiTypography-h2 {
        margin-right: 16px;
    }
`;

export const SingleLegendItem = (props: { keyName: string; value: number | boolean, keyIdentifier: string }): JSX.Element => {
    const { validationStatus } = useSelector(getContactsStore);
    const { keyName, value, keyIdentifier } = props;
    const valuenumber = value !== false ? +value : 0;
    const percentage = `${((valuenumber / validationStatus.Contacts) * 100).toFixed(2)}%`;

    return (
        <LegendItem key={keyName}>
            <Typography variant="body1">
                <span className="legendColor" style={{ backgroundColor: validationColors[keyName] }} />
                {keyIdentifier}
            </Typography>
            <NumberRow>
                <Typography variant="h2">{valuenumber}</Typography>
                <Typography variant="body1" bodyVariant='help'>{percentage}</Typography>
            </NumberRow>
        </LegendItem>
    );
};
